import { render, staticRenderFns } from "./SiInputSwitch.vue?vue&type=template&id=99c052b6&scoped=true&lang=html&"
import script from "./SiInputSwitch.vue?vue&type=script&lang=js&"
export * from "./SiInputSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c052b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
